import { PropsWithChildren } from 'react';
import * as React from 'react';

export const NavbarNavMenuUserMenu = (props: PropsWithChildren<unknown>) => (
    <ul className="dropdown-menu company-selection" role="menu">
        {props.children}
    </ul>
);
